import { call, put, select } from 'redux-saga/effects'
import { ApiResponse } from 'apisauce'

import { ApplicationState } from 'src/core/store'
import { ClientNotifyCatch } from 'src/config/bugsnag'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'
import i18n from 'src/config/i18n'

import api from 'src/services/api'
import * as RequestsActions from '../requests/actions'

import { ResponseDataApprovals } from './types'
import * as ApprovalsActions from './actions'

export const PAGE_SIZE_APPROVALS = 10

export function* getApprovals({
  payload: { options }
}: ReturnType<typeof ApprovalsActions.getApprovals>) {
  try {
    const {
      approvals,
      me: { organization }
    } = yield select((state: ApplicationState) => state)

    let statusParams = ''

    if (approvals.filterStatus) {
      statusParams = approvals.filterStatus
        .map((status: string) => `&${status}=True`)
        .join('')
    }

    const response: ApiResponse<ResponseDataApprovals> = yield call(
      api.get,
      `users/me/approvals/requests?page_size=10&page=${
        options.page || 1
      }${statusParams}${
        options.request_ids && !!options.request_ids.length
          ? `&request_ids=${options.request_ids.join(',')}&organization_id=${
              organization.organization_id
            }`
          : ''
      }`
    )

    if (response.ok) {
      yield put(ApprovalsActions.getApprovalsSuccess(response.data))
      yield put(
        RequestsActions.setRequestTotals({
          request_totals: response.data.request_totals
        })
      )
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(ApprovalsActions.getApprovalsFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga getApprovals', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(ApprovalsActions.getApprovalsFailure(message))
  }
}

export function* setApprovalStatus({
  payload: { justification, request_id, request_approval_ids, status }
}: ReturnType<typeof ApprovalsActions.setApprovalStatus>) {
  try {
    const {
      me: { organization }
    } = yield select((state: ApplicationState) => state)

    const response: ApiResponse<ResponseDataApprovals> = yield call(
      api.post,
      '/users/me/approvals/requests',
      {
        request_approvals: request_approval_ids.map(request_approval_id => ({
          request_approval_id: +request_approval_id,
          request_id: +request_id,
          organization_id: organization.organization_id,
          status,
          justification
        }))
      }
    )

    if (response.ok) {
      const requestNumber = response.data?.requests?.[0]?.request_number || ''
      const message = i18n.t(
        'common.push-notifications.request-changed-successful',
        { value: requestNumber }
      )
      yield put(ApprovalsActions.setApprovalStatusSuccess(message))
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(ApprovalsActions.setApprovalStatusFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga setApprovalStatus', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(ApprovalsActions.setApprovalStatusFailure(message))
  }
}
